import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { NetworkIcon, ShieldAlertIcon, UserXIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    title: 'Complex Core Integrations',
    description: 'Legacy systems create costly, fragile connections that slow down innovation and increase maintenance overhead.',
    icon: NetworkIcon
  }, {
    title: 'Quantum Computing Threats',
    description: 'Current encryption standards face obsolescence. "Store now, decrypt later" attacks are already capturing sensitive financial data.',
    icon: ShieldAlertIcon
  }, {
    title: 'Limited Customer Intelligence',
    description: 'Generic product offerings miss individual customer needs, leading to lower conversion rates and diminished loyalty.',
    icon: UserXIcon
  }, {
    title: 'Revenue Leakage',
    description: 'Lucrative micro-lending and P2P opportunities are being lost to agile fintech competitors outside your ecosystem.',
    icon: TrendingDownIcon
  }];
  return <section id="platform" className="py-24 bg-navy relative" data-id="element-456">
      <div className="max-w-7xl mx-auto px-6" data-id="element-457">
        <FadeIn className="mb-16 md:w-2/3" data-id="element-458">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-459">
            Traditional Infrastructure Wasn't Built for What's Coming
          </h2>
          <p className="text-xl text-gray-400" data-id="element-460">
            Financial institutions are caught between maintaining legacy systems
            and defending against next-generation threats, all while losing
            ground to agile fintechs.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-461">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <StaggerItem key={index} data-id="element-462">
                <div className="bg-slate border border-white/5 rounded-xl p-8 h-full relative overflow-hidden group hover:border-red-500/30 transition-colors duration-300" data-id="element-463">
                  {/* Subtle red accent line */}
                  <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-red-500/50 to-transparent opacity-50" data-id="element-464"></div>

                  <div className="flex items-start gap-5" data-id="element-465">
                    <div className="p-3 rounded-lg bg-red-500/10 text-red-400 group-hover:bg-red-500/20 transition-colors duration-300" data-id="element-466">
                      <Icon className="w-6 h-6" data-id="element-467" />
                    </div>
                    <div data-id="element-468">
                      <h3 className="text-xl font-semibold text-white mb-3" data-id="element-469">
                        {problem.title}
                      </h3>
                      <p className="text-gray-400 leading-relaxed" data-id="element-470">
                        {problem.description}
                      </p>
                    </div>
                  </div>
                </div>
              </StaggerItem>;
        })}
        </StaggerContainer>
      </div>
    </section>;
}